import { createAction, props } from '@ngrx/store'

export const SOURCE = '[Contract Validity Filter]'

export const resetState = createAction(
    `${SOURCE} ResetState`,
)

export const setState = createAction(
    `${SOURCE} SetState`, props<{ items: any }>()
)

export const toggleState = createAction(
    `${SOURCE} ToggleState`, props<{ item: any }>()
)